var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 18C36.9853 18 39 15.9853 39 13.5C39 11.0147 36.9853 9 34.5 9C32.0147 9 30 11.0147 30 13.5C30 15.9853 32.0147 18 34.5 18Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 20.25C30.78 20.25 27.75 17.22 27.75 13.5C27.75 12.42 28.035 11.415 28.485 10.5H17.28C12.105 10.5 9 13.59 9 18.78V30.705C9 35.91 12.105 39 17.28 39H29.205C34.395 39 37.485 35.91 37.485 30.72V19.515C36.585 19.965 35.58 20.25 34.5 20.25Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3496 24.5404C21.4946 24.2704 20.5796 24.4204 19.9346 24.9304C19.2746 24.4204 18.3746 24.2704 17.5346 24.5404C15.6896 25.1404 15.1046 27.2404 15.6296 28.8604C16.4246 31.3204 19.0196 32.5954 19.9496 32.5954C20.8646 32.5954 23.5046 31.2904 24.2696 28.8604C24.7946 27.2404 24.1946 25.1404 22.3496 24.5404Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFavorite);
export default __webpack_public_path__ + "static/media/notificationFavorite.0313fdc8c3530f7172855ebdc9c6192f.svg";
export { ForwardRef as ReactComponent };